import { render } from "./ContactCoursewareModal.vue?vue&type=template&id=3fcdc708"
import script from "./ContactCoursewareModal.vue?vue&type=script&lang=js"
export * from "./ContactCoursewareModal.vue?vue&type=script&lang=js"
script.render = render

export default script